<template>
  <div class="video" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <video class="video_box" controls v-if="data.video.src" :poster="data.fengValue ? data.infoImg.url : ''">
      <source :src="data.video.src" type="video/mp4">
    </video>
    <img class="img_box" v-else :src="defUpload" alt="defUpload">
  </div>
</template>
<script>
import defUpload from '../../assets/image-upload.jpg'
export default {
  name: 'videoPreview',
  components: { defUpload },
  props: {
    data: Object
  },
  data () {
    return {
      defUpload: defUpload
    }
  }
}
</script>
<style scoped>
.video_box,
.img_box {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/video/videoPreview.vue